import { BaseResourceModel } from '../../shared/models/base-resource.model';
import { BaseServiceType } from '../bases/base-service-type.model';
import { Category } from '../bases/categories/category.model';
import { ClientContract } from './client-contract.model';
import { ClientProposal } from './client-proposal.model';
import { TechnicalRoutineClient } from '../technical-routine/technical-routine-client.model';

export interface ClientProfile {
    sector_ids?: string;
    service_type_id?: number;
    manipulation_level?: string;
    number_collaborators?: number;
    number_shifts?: number;
    avg_meals_per_day?: number;
    has_buffet?: number;
    has_delivery?: number;
    has_own_production?: number;
    has_public_service?: number;
    number_manipulators?: number;
    number_attendants?: number;
    food_production_predominant_type?: string;
    food_type_predominant?: string;
    public_served_type?: string;
    production_volume?: string;
    menu_variety?: string;
    food_rotativity?: string;
    has_raw_animal_origin_foods?: number;
    has_ready_to_eat_foods?: number;
    has_prepared_in_advance?: number;
    uses_food_reuse?: number;
    production_is_standardized?: string;
    has_preparation_recipe_sheets?: number;
    production_distribution?: string;
    production_peak_time?: string;
    production_run_mode?: string;
    has_preparation_outside_service_hours?: number;
    organization_level?: string;
    team_follows_standards?: string;
    technical_responsible_dependency_level?: string;
    receiving_frequency?: string;
    supply_type?: string;
    has_receiving_during_operation?: number;
    exposure_time_level?: string;
    has_simultaneous_raw_and_ready?: number;
    food_safety_maturity_level?: string;
    improvement_openness_level?: string;
    team_engagement_level?: string;

    // campos calculados automaticamente
    operational_complexity_score?: number;
    operational_complexity_level?: string;
    food_safety_maturity_score?: number;
    food_safety_maturity_classification?: string;
    operational_profile_summary?: string;
    operational_profile_guidance?: string;

    service_type?: BaseServiceType;
}

export class Client extends BaseResourceModel {

    constructor(
        public id?: number,
        public category_id?: number,
        public parent_id?: number,
        public type?: string,
        public code?: string,
        public name?: string,
        public company_name?: string,
        public cnpj?: string,
        public responsible_name?: string,
        public responsible_email?: string,
        public responsible_phone?: string,
        public responsible_technical?: string,
        public responsible_technical_email?: string,
        public responsible_technical_phone?: string,
        public email?: string,
        public site?: string,
        public facebook?: string,
        public instagram?: string,
        public file_name?: string,
        public street?: string,
        public number?: string,
        public complement?: string,
        public neighborhood?: string,
        public city?: string,
        public state?: string,
        public archived?: number,
        public zipcode?: string,
        public phone?: string,
        public phone_2?: string,
        public start?: string,
        public comments?: string,
        public status?: number,
        public owner?: boolean,
        public number_employees?: number,
        public number_handlers?: number,
        public technical_routine_client_active?: boolean,
        public technical_routine_client?: TechnicalRoutineClient,
        public category?: Category,
        public clients_contract?: ClientContract,
        public clients_contracts?: ClientContract[],
        public clients_proposal?: ClientProposal,
        public clients_proposals?: ClientProposal[],
        public clients_contracts_count?: number,
        public clients_proposals_count?: number,
        public profile?: ClientProfile,
    ) {
        super();
    }

    static fromJson(jsonData: any): Client {
        return Object.assign(new Client(), jsonData);
    }
}
